<template>
  <div>
    <van-nav-bar left-arrow @click-left="onClickLeft" class="nav_bar">
      <!-- <img src="@/assets/images/x3-01.png" @click="nonstop" slot="right" /> -->
    </van-nav-bar>
    <van-swipe class="video-father" id="van_swipes" @change="onChange">
      <van-swipe-item :class="{ showvideo: cartShow }" v-if="dataStatus">
        <div slot="default">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
        </div>
      </van-swipe-item>
      <van-swipe-item v-for="(items, i) in producImgList" :key="i">
        <img class="van_swipe_img" :src="items" />
      </van-swipe-item>
      <div class="custom-indicator" slot="indicator">
        <span v-if="dataStatus" class="custom_span"
          >{{ current + 1 }}/{{ getProductLength + 1 }}</span
        >
        <span v-else class="custom_span"
          >{{ current + 1 }}/{{ getProductLength }}</span
        >
      </div>
    </van-swipe>
    <price-area :tenDiscount="tenDiscount" :priceArea="priceArea" />
    <div class="boder_top rolled"></div>
    <div id="store_list" class="store_navigation"></div>
    <div id="product_list" class="product_details store_recommend">
      <h3>产品详情</h3>
      <div class="bottom_line"></div>
      <div :class="{ showvideo: cartShow }" v-if="descriptionVideoUrlShow">
        <video
          controlslist="nodownload"
          ref="productVido"
          muted
          autoplay
          controls
          :src="productsList.descriptionVideoUrl"
          class="video-detaile"
        >
          您的手机不支持视频播放。
        </video>
      </div>
      <div
        v-if="mobileDescriptionShow"
        class="product-mobile"
        v-html="productsList.mobileDescription"
      ></div>
    </div>
    <div class="bottom_bar">
      <van-goods-action>
        <van-button class="bottom_bar_btn" @click="btnClick" round type="danger"
          >立即购买</van-button
        >
      </van-goods-action>
    </div>
    <!-- 到店自提弹窗 -->
    <div class="self_proposal">
      <van-popup
        v-model="showPicker"
        @click-overlay="overlay"
        position="bottom"
      >
        <van-picker
          title="选择到店自提"
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showCancel"
        />
      </van-popup>
    </div>
    <!-- 加入购物车弹窗 -->
    <div class="cart-popup">
      <van-popup
        @click-overlay="cartOverlay"
        round
        v-model="cartShow"
        position="bottom"
      >
        <div class="cart-head">
          <van-row type="flex">
            <van-col>
              <img v-if="mainImg" :src="productsList.mainPictureUrl" />
            </van-col>
            <van-col>
              <div class="cart-current">
                <span class="cart-discounted">折后价</span>
                <span class="cart-original">￥{{ minPriceNum }}</span>
              </div>
              <div class="cart_price">
                <span>原价</span>
                <span>￥{{ productsList.price }}</span>
                <span v-if="tenDiscount">{{ productsList.discount }}折</span>
              </div>
              <div class="cart_price" v-if="stockShow">
                <span>库存:{{ stockNum }}</span>
              </div>
            </van-col>
          </van-row>
          <!-- 购买数量 -->
          <div class="pay_num">
            <van-cell class="pay_title" title="购买数量">
              <span v-if="showStocks">
                库存不足
                <!-- <span v-if="showStocksNum">仅剩一件</span> -->
              </span>
              <van-stepper
                v-model="payNum"
                @minus="minus"
                @plus="plus"
                :max="stockNum"
                @overlimit="overlimit"
                disable-input
              />
            </van-cell>
          </div>
          <!-- 选择sku规格 -->
          <div
            class="radios-sku"
            v-for="(ProductItem, n) in simulatedDATA.specifications"
            :key="n"
          >
            <p class="radio-title">{{ ProductItem.name }}</p>
            <van-radio-group
              v-for="(items, i) in ProductItem.item"
              :key="i"
              v-model="getRadios[n]"
              @change="radioChange"
            >
              <van-radio class="radio-name" :name="items.name" shape="square">{{
                items.name
              }}</van-radio>
            </van-radio-group>
          </div>
          <!-- 服务方式 -->
          <div class="pay_service">
            服务方式
            <span class="pay_explain"
              >（选择您需要的服务方式，只可单选1种）</span
            >
            <div class="pay_radio">
              <van-radio-group v-model="radios" direction="horizontal">
                <van-radio
                  v-if="selfStores"
                  shape="square"
                  name="1"
                  @click="picker"
                  >到店自提</van-radio
                >
                <van-radio
                  v-if="notSelfStores"
                  shape="square"
                  name="2"
                  @click="storeExpress"
                  >快递</van-radio
                >
              </van-radio-group>
            </div>
          </div>
          <div>
            <div class="btn">
              <div class="btn_again" @click="onBuyClicked">提交订单</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <vueToTop
      :top="1300"
      :size="35"
      :right="20"
      :bottom="100"
      :type="12"
    ></vueToTop>
    <toast-show :showMessage="showMessage" :showToast="showToast" />
  </div>
</template>

<script>
import { log } from 'util'
import defaultImg from '@/assets/images/default.png'
import toastShow from '@/components/content/toastShow'
import priceArea from '@/components/content/priceArea'
import follow from '@/api/follow.js'
import Cookies from 'js-cookie'
import { domainNameConstant, FRONTEND_HOST } from '@/config/domainnameconstant'

import {
  queryProducts,
  currentBuy,
  storeBasicInformation,
  productSku,
  addCarts,
  dataCollection,
} from '@/api/productsDetaile'
import {
  getAddressList,
  setDefaultAddress,
  getDefaultAddress,
} from '@/api/shippingAddress'
import increaseFpClickCountMixin from '@/mixins/increaseFpClickCountMixin'
import { wxInit } from '@/config/lib'

export default {
  name: 'moreshpes',
  mixins: [increaseFpClickCountMixin],
  data() {
    return {
      platform: 1, // 查询平台 0：播商友圈 1：普惠平台 3：中药香
      //商家信息接口
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            // type: 'application/x-mpegURL',
            // src: 'http://java-test.jmzgo.com/mall/www/videos/0000018.mp4',
            src: '',
          },
        ],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '.', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: false, // 全屏按钮
        },
      },
      mobileDescriptionShow: false,
      videoImg: require('@/assets/images/videoImg.png'),
      tenDiscount: true,
      skuIdTrue: false,
      radioStatus: false,
      mainImg: false,
      productsId: '',
      dataStatus: false,
      descriptionVideoUrlShow: false,
      showStocks: false,
      //删除sku开
      shopingAddId: 0,
      isStoredId: '',
      isProductId: '',
      selfObject: {},
      //sku删结
      getMethods: '',
      storeId: '',
      payNum: 1,
      getstoreId: '',
      selfStoreId: [],
      stockShow: false,
      minPriceNum: '',
      stockNum: 100,
      storeNamesList: [],
      selfStores: false,
      notSelfStores: false,
      goodsSkuId: '',
      getRadios: [],
      showPicker: false,
      columns: ['', '', '', ''],
      storeBasicList: {},
      basicTelephone: [],
      addressName1: [],
      addressName2: [],
      addressName3: [],
      address1: '',
      address2: '',
      address3: '',
      country: [],
      skusList: [],
      //商结束
      radios: '',
      cartShow: false,
      priceArea: {
        discounted: '',
        original: '',
        price: '',
        price_discount: '',
        pricetitle: '',
        right_pay: '',
        right_watch: '',
      },
      showMessage: '',
      showToast: false,
      current: 0,
      showPopu: false,
      active: 0,
      isShowTab: false,
      isActived1: false,
      isActived2: false,
      isActived3: false,
      isActived4: false,
      productsList: {},
      producImgList: [],
      //sku测试
      simulatedDATA: {
        //模拟后台返回的数据 多规格
        difference: [
          //所有的规格可能情况都在这个数组里
          {
            id: '19',
            price: '200.00',
            stock: '19', //库存
            difference: '100,白色', //此规格的属性键值
          },
          {
            id: '20',
            price: '100.00',
            stock: '29',
            difference: '200,白色',
          },
          {
            id: '21',
            price: '300.00',
            stock: '10',
            difference: '100,黑色',
          },
          {
            id: '22',
            price: '900.00',
            stock: '0',
            difference: '200,黑色',
          },
          {
            id: '25',
            price: '90.00',
            stock: '0',
            difference: '100,蓝色',
          },
          {
            id: '26',
            price: '40.00',
            stock: '20',
            difference: '200,蓝色',
          },
        ],
        //展示给用户看的规格
        specifications: [
          {
            //这里是要被渲染字段
            name: '尺寸',
            item: [
              {
                name: '100',
              },
              {
                name: '200',
              },
            ],
          },
          {
            name: '颜色',
            item: [
              {
                name: '白色',
              },
              {
                name: '蓝色',
              },
              {
                name: '黑色',
              },
            ],
          },
        ],
      },
    }
  },
  components: {
    toastShow,
    priceArea,
  },
  watch: {
    // radioStatus(val, oldVal) {
    //   console.log('valsssssss', val, oldVal)
    //   if (val) {
    //     this.payNum = 1
    //   }
    // },
    goodsSkuId(val, oldVal) {
      console.log('valsssssss', val, oldVal)
      if (val) {
        this.payNum = 1
      }
    },
  },
  created() {
    if (this.$route.query.platform) {
      this.platform = this.$route.query.platform
    }
    this.storeId = this.$route.query.storeId
    this.productsId = this.$route.query.id
    this.shopingAddId = this.$route.query.shopingAddId
    this.toCollection()
  },
  mounted() {
    this.getDetailsList()
    // this.BasicInformation()
    this.getproductSku()
    // this.$refs.player.init();//会变成两次
  },

  computed: {
    getProductLength() {
      return this.producImgList.length
    },
  },
  methods: {
    //采集访客数据
    toCollection() {
      let storeId = this.storeId
      dataCollection(storeId).then((res) => {
        if (res.data.code == 200) {
        }
      })
    },
    //购物车弹窗遮罩层
    cartOverlay() {
      // if (this.productsList.mainVideoUrl) {
      //   this.dataStatus = true
      // }
      // if (this.productsList.descriptionVideoUrl) {
      //   this.descriptionVideoUrlShow = true
      // }
      this.getMethods = ''
      console.log('this.getMethods', this.getMethods)

      this.radioNull()
      // this.getRadios = []
    },
    //电话
    callPhone(phoneNumber) {
      window.location.href = 'tel:' + phoneNumber
    },
    //点击增加按钮触发去掉库存不足
    plus() {
      this.showStocks = false
    },
    //点击减少按钮触发去掉库存不足
    minus() {
      this.showStocks = false
    },
    //库存不足显示
    overlimit() {
      this.showStocks = true
      // if (this.payNum === 1) {
      //   this.showStocks = true
      //   this.showStocksNum = true
      // }
    },
    //到店自提radio按钮
    radioNull() {
      this.radios = ''
    },
    onConfirm(value) {
      this.value = value
      let valueId = this.columns.indexOf(value)
      this.getstoreId = this.selfStoreId[valueId]
      console.log('自提门店name+id', value, this.getstoreId)
      this.showPicker = false
    },
    showCancel() {
      this.getMethods = ''
      console.log('this.getMethods22222222', this.getMethods)
      this.showPicker = false
      this.radioNull()
    },
    overlay() {
      this.getMethods = ''
      console.log('this.getMethods111111111', this.getMethods)
      console.log('遮罩层')
      this.radioNull()
    },
    //到店自提radio
    picker() {
      this.radios = '1'
      this.getMethods = 0
      console.log('自提提货方式', this.getMethods)
      if (this.storeNamesList.length > 0 && this.storeNamesList[0] !== '') {
        this.columns = this.storeNamesList
        console.log('this.columns', this.columns)
        if (this.columns.length == 1) {
          // console.log('this.selfStoreId',this.selfStoreId[0]);
          this.getstoreId = this.selfStoreId[0]
        } else if (this.columns.length > 1) {
          this.showPicker = true
          console.log('执行到了')
        }
      }
    },
    //快递radio
    storeExpress() {
      this.radios = '2'
      this.getMethods = 1
      console.log('快递提货方式', this.getMethods)
    },
    //sku的radio
    // radioChange() {
    //   // console.log('event', this.getRadios)
    //   let radioTxt = this.getRadios.join(',')
    //   // console.log(radioTxt)
    //   this.simulatedDATA.difference.forEach((val, index) => {
    //     // console.log('val', val)
    //     if (radioTxt == val.difference) {
    //       // console.log('匹配成功')
    //       this.goodsSkuId = val.id
    //       console.log('this.goodsSkuId', this.goodsSkuId)
    //       this.minPriceNum = val.price
    //       this.stockShow = true
    //       this.stockNum = val.stock
    //     }
    //   })
    // },
    radioChange(val) {
      // console.log('val111111', val)

      this.simulatedDATA.difference.forEach((val, index) => {
        let valArr = val.difference.split(',')
        // console.log(
        //   'this.simulatedDATA.specifications',
        //   this.simulatedDATA.specifications
        // )
        if (this.simulatedDATA.specifications.length == 1) {
          let retun = valArr.indexOf(this.getRadios[0]) !== -1
          this.radioStatus = retun
        } else if (this.simulatedDATA.specifications.length == 2) {
          let retun =
            valArr.indexOf(this.getRadios[0]) !== -1 &&
            valArr.indexOf(this.getRadios[1]) !== -1
          this.radioStatus = retun
          // console.log('this.radioStatus', this.radioStatus)
        }
        if (this.radioStatus) {
          console.log(this.getRadios)
          this.skuIdTrue = true
          // console.log('匹配成功')
          this.goodsSkuId = val.id
          console.log('this.goodsSkuId', this.goodsSkuId)
          this.minPriceNum = val.price
          this.stockShow = true
          this.stockNum = val.stock
          // this.maxNum = val.stock
        }
      })
    },

    //获取产品sku信息
    getproductSku() {
      productSku({
        productId: this.$route.query.id,
        platformType: this.platform === 1 ? 'PuHui' : 'Zyx',
      })
        .then((res) => {
          if (res.data.code === 200) {
            // console.log('sku打印看', res.data.data)
            this.skusList = res.data.data

            // 规格去重分组
            var mapper = {}
            var group = {}
            this.skusList.forEach((r, i) => {
              r.specifications.forEach((rr, ii) => {
                if (!group.hasOwnProperty(rr.productAttributeId)) {
                  group[rr.productAttributeId] = []
                  mapper[rr.productAttributeId] =
                    's' + Object.keys(group).length
                }
                try {
                  group[rr.productAttributeId].forEach((rrr, iii) => {
                    if (rrr.val === rr.val) throw new Error()
                  })
                  group[rr.productAttributeId].push(rr)
                } catch (e) {}
              })
            })
            // tree
            var tree = []
            Object.keys(group).forEach((r, i) => {
              const item = group[r]
              var treeItem = {
                name: item[0].productAttributeName,
                item: [],
              }
              item.forEach((rr, ii) => {
                treeItem['item'].push({
                  name: rr.val,
                })
              })
              tree.push(treeItem)
            })
            // list
            var list = []
            this.skusList.forEach((r, i) => {
              const listItem = {}
              listItem.id = r.id
              listItem.price = r.platformPrice
              listItem.stock = r.stock
              listItem.difference = ''
              r.specifications.forEach((rr, ii) => {
                listItem.difference = listItem.difference + rr.val + ','
              })

              listItem.difference = listItem.difference.substring(
                0,
                listItem.difference.length - 1
              )

              list.push(listItem)
            })
            this.simulatedDATA.specifications = tree
            this.simulatedDATA.difference = list
            // console.log('tree是specifications', tree)
            console.log('list是difference', list)
            //默认选择规格
            if (this.simulatedDATA.difference[0].difference) {
              this.getRadios[0] = this.simulatedDATA.difference[0].difference
              this.goodsSkuId = this.simulatedDATA.difference[0].id
              this.stockNum = this.simulatedDATA.difference[0].stock
              this.stockShow = true
              let differenceList = this.simulatedDATA.difference[0].difference.split(
                ','
              )
              if (differenceList.length > 1) {
                this.getRadios[0] = differenceList[0]
                this.getRadios[1] = differenceList[1]
                this.stockShow = true
                this.stockNum = this.simulatedDATA.difference[0].stock
              }
            }
            //当没有规格选择时，默认直接拿id
            if (this.skusList[0].specifications.length === 0) {
              this.goodsSkuId = this.skusList[0].id
              // console.log('this.skusList[0]十大', this.skusList[0])
              this.stockNum = this.skusList[0].stock
              this.skuIdTrue = true
            }
          }
        })
        .catch((result) => {
          console.log('失败sku', result)
        })
    },
    //获取商家基本信息
    BasicInformation() {
      let getUserId = this.productsList.userId
      storeBasicInformation({ userId: getUserId }).then((res) => {
        if (res.data.code === 200) {
          this.storeBasicList = res.data.data
          this.basicTelephone = this.storeBasicList.telephone.split(',')
        }
      })
    },
    //查询详情页接口
    getDetailsList() {
      const obj = {
        storeId: this.storeId,
        platform: this.platform,
      }
      queryProducts({
        id: this.$route.query.id,
        obj,
      }).then((res) => {
        if (res.data.code === 200) {
          // console.log('成功')
          this.productsList = res.data.data
          console.log('shuju', res.data.data)

          if (this.$isWeixin()) {
            //微信分享
            let shareData = {
              shareTitle: '消费扶贫，你我同行',
              shareDes: this.productsList.title,
              shareImgUrl: this.productsList.mainPictureUrl, //封面图这个图片地址域名不能有#，所以直接固定图片地址了
              shareUrl: window.location.href,
            }
            wxInit(shareData)
            this.$wx.miniProgram.postMessage({
              data: {
                title: this.productsList.title,
                imageUrl: this.productsList.mainPictureUrl,
              },
            })
          }
          //处理10折
          if (this.productsList.discount == 10) {
            this.tenDiscount = false
          }
          // //富文本处理
          if (this.productsList.mobileDescription) {
            this.mobileDescriptionShow = true
            this.productsList.mobileDescription = this.productsList.mobileDescription.replace(
              /(<img [^>]*src=)(["'])((..)?\/)/gi,
              '$1$2//' + domainNameConstant + '/'
            )
          }

          // //判断是否有视频
          // if (this.productsList.mainVideoUrl) {
          //   this.dataStatus = true
          // }
          // if (this.productsList.descriptionVideoUrl) {
          //   this.descriptionVideoUrlShow = true
          // }
          // 富文本处理测试服
          // this.productsList.mobileDescription = this.productsList.mobileDescription.replace(
          //   /(<img [^>]*src=)(["'])((..)?\/)/gi,
          //   '$1$2//' + domainNameConstant + '/'
          // )
          // 富文本处理正式服
          // this.productsList.mobileDescription = this.productsList.mobileDescription.replace(
          //   /(<img [^>]*src=)(["'])((..)?(\/mall)?\/)/gi,
          //   '$1$2' + `http://mallstatic.jmzgo.com` + '/'
          // )
          // 判断是否有视频
          if (this.productsList.mainVideoUrl) {
            this.dataStatus = true
          }
          if (this.productsList.mainVideoUrl) {
            this.playerOptions.sources[0].src = this.productsList.mainVideoUrl
            this.playerOptions.poster = this.productsList.mainVideoCoverUrl
          }

          if (this.productsList.descriptionVideoUrl) {
            this.descriptionVideoUrlShow = true
          }
          //获取商家基本信息接口调起
          this.BasicInformation()
          // console.log(this.productsList)
          this.getMethods = this.productsList.deliveryMethod
          this.getdeliveryMethod(this.productsList.deliveryMethod)
          //自提门店弹窗
          if (this.productsList.storeNames) {
            this.storeNamesList = this.productsList.storeNames.split(',')
          }
          // console.log('this.storeNamesList', this.storeNamesList)
          //购物车弹窗规格原价钱
          this.minPriceNum = this.productsList.minPrice
          //只提门店id
          if (this.productsList.storeIds) {
            this.selfStoreId = this.productsList.storeIds.split(',')
          }
          let salesNum = ''
          let loadCounts = ''
          if (this.productsList.salesVolume) {
            if (this.productsList.salesVolume != 0) {
              salesNum = this.productsList.salesVolume + '人付款'
            }
          }
          if (this.productsList.loadCount) {
            if (this.productsList.loadCount != 0) {
              loadCounts = '浏览' + this.productsList.loadCount
            }
          }
          this.priceArea = {
            discounted: '折后价',
            original: this.productsList.minPrice,
            price: this.productsList.price,
            price_discount: this.productsList.discount + '折',
            pricetitle: this.productsList.title,
            right_pay: salesNum,
            right_watch: loadCounts,
          }
          // //头部图片
          let listUrls = this.productsList.albumPictureUrls
          if ((listUrls = '')) {
            this.producImgList = []
          } else {
            let listUrls = this.productsList.albumPictureUrls
            if (listUrls) {
              this.producImgList = listUrls.split(',')
            }
          }
          //判断是否有主图
          if (this.productsList.mainPictureUrl) {
            this.mainImg = true
            this.producImgList.unshift(this.productsList.mainPictureUrl)
            // console.log('this.producImgListllll', this.producImgList)
          }
        }
      })
    },
    //判断提货方式
    getdeliveryMethod(index) {
      let arr = index.split(',')
      // console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        if (arr[1] == 1 && arr[0] == 0) {
          this.selfStores = true
          this.notSelfStores = true
        } else if (arr[0] == 1) {
          this.selfStores = false
          this.notSelfStores = true
        } else if (arr[0] == 0) {
          this.selfStores = true
          this.notSelfStores = false
        }
      }
    },
    getVideo() {
      if (this.dataStatus) {
        this.$refs.vido['disablePictureInPicture'] = true
      }
      if (this.descriptionVideoUrlShow) {
        this.$refs.productVido['disablePictureInPicture'] = true
      }
    },
    onBuyClicked() {
      // console.log('this.goodsSkuId', this.goodsSkuId)
      const parameter = {
        storeId: parseInt(this.storeId),
        deliveryMethod: this.getMethods,
        platformType: this.platform,
        productSkuId: this.goodsSkuId,
        quantity: this.payNum,
        storeSelfMentionId: this.getstoreId,
        id: this.$route.query.id,
      }
      // console.log('curerentss', curerent)

      if (this.getstoreId === '') {
        delete parameter.storeSelfMentionId
      }
      const token = Cookies.get('token')
      if (!token) {
        this.showMessage = '您还未登录,即将跳到登录界面'
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
          let host = window.location.host
          console.log('host', host)
          console.log('window.location.href', window.location.href)

          console.log('host:', host)
          if (this.getMethods === 0) {
            this.$router.push({
              path: '/login',
              query: {
                callbackUrl:
                  `${FRONTEND_HOST}/payproduct/confirmation?storeId=` +
                  parseInt(this.storeId) +
                  '&deliveryMethod=' +
                  this.getMethods +
                  '&platformType=' +
                  1 +
                  '&productSkuId=' +
                  this.goodsSkuId +
                  '&quantity=' +
                  this.payNum +
                  '&storeSelfMentionId=' +
                  this.getstoreId +
                  '&id=' +
                  this.$route.query.id +
                  '',
              },
            })
          }
          if (this.getMethods === 1) {
            this.$router.push({
              path: '/login',
              query: {
                callbackUrl:
                  `${FRONTEND_HOST}/payproduct/newaddress?storeId=` +
                  parseInt(this.storeId) +
                  '&deliveryMethod=' +
                  this.getMethods +
                  '&platformType=' +
                  1 +
                  '&productSkuId=' +
                  this.goodsSkuId +
                  '&quantity=' +
                  this.payNum +
                  '&id=' +
                  this.$route.query.id +
                  '',
              },
            })
          }
        }, 1000)
      } else if (this.storeId == '') {
        this.showMessage = '商铺为空'
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
        }, 2000)
      }
      //  else if (this.skuIdTrue == false) {
      //   this.showMessage = '请选择规格'
      //   this.showToast = true
      //   setTimeout(() => {
      //     this.showToast = false
      //   }, 2000)
      // }
      else if (this.getMethods === '') {
        this.showMessage = '请选择服务方式'
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
        }, 2000)
      } else if (this.payNum == '' || this.stockNum == 0) {
        this.showMessage = '商品库存不足'
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
        }, 2000)
      } else {
        if (this.getMethods === 0) {
          this.$router.push({
            path: '/help-mall/order-confirmation',
            query: parameter,
          })
        } else if (this.getMethods === 1) {
          // let nowExpress = {
          //   productSkuId: this.goodsSkuId,
          //   quantity: this.payNum,
          //   storeId: this.storeId,
          //   deliveryMethod: this.getMethods,
          //   platformType: 1
          // }
          this.$router.push({
            path: '/help-mall/order-newaddress',
            query: parameter,
          })
        }
      }
    },
    clickImg() {},
    onClickLeft() {
      console.log('返回')
      this.$router.push({
        path: '/themepage/index',
      })
    },
    showPopup() {
      this.showPopu = true
    },
    btnClick() {
      if (this.selfStores && this.notSelfStores) {
        this.storeExpress()
      } else if (this.notSelfStores) {
        this.storeExpress()
      } else if (this.selfStores) {
        if (this.storeNamesList.length == 1) {
          // console.log('this.storeNamesList.length', this.storeNamesList)
          this.picker()
        }
      }
      this.cartShow = !this.cartShow
    },

    onChange(index) {
      this.current = index
    },
    //导航
    navigationClick() {
      console.log('导航')
      // let navigation = {
      //   latitude: this.storeBasicList.latitude,
      //   longitude: this.storeBasicList.longitude,
      //   shopName: this.storeBasicList.storeName
      // }
    },
  },
}
</script>
<style lang="less" scoped>
.showvideo {
  display: none;
}
* {
  padding: 0px;
  margin: 0px;
}

//导航栏右侧图片
.nav_bar img {
  width: 25px;
  height: 25px;
  margin: 0px 7.5px;
}
.van-nav-bar {
  z-index: 999;
  opacity: 0.8;
  position: fixed;
  top: 0;
  width: 375px;
  height: 45px;
  line-height: 45px;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
  font-size: 18px;
}
//详情位置视频
.video-detaile {
  width: 375px;
  height: 350px;
  object-fit: fill;
}
//轮播图
.video-father {
  margin-top: 44.5px;
  /deep/ .video-js.vjs-fluid,
  .video-js.vjs-16-9,
  .video-js.vjs-4-3 {
    width: 375px;
    height: 375px;
    object-fit: fill;
  }
  position: relative;
}
.van_swipe_img {
  height: 375px;
  width: 375px;
  vertical-align: middle;
}
.custom-indicator {
  position: absolute;
  right: 20px;
  bottom: 25px;
  width: 33px;
  // height: 32px;
  text-align: center;
  color: white;
  background: #231815;
  // background: red;
  opacity: 0.6;
  border-radius: 7.5px;
}
.custom_span {
  font-size: 12px;
  line-height: 20px;
}

//优惠卷字体
.boder_top {
  border-top: 5px #efefef solid;
}
//店铺头像css
.store_navigation {
  // .van-card[data-v-4999a303] {
  //   height: 200px;
  // }
  .van-tag[data-v-9571ae72][data-v-9571ae72][data-v-9571ae72] {
    margin: 5px 0px 7.5px 0;
    padding: 2.5px 3.5px;
  }
  margin-top: 7.5px;
  position: relative;
}
.store_title {
  width: 70%;
  font-size: 13px;
}
// .van-ellipsis {
//   margin-top: 20px;
//   font-size: 26px;
//   height: 35px;
//   line-height: 35px;
// }
.store-address {
  margin-top: 10px;
  font-size: 12px;
  // height: 35px;
  line-height: 17.5px;
}
.store_icon {
  position: absolute;
  right: 2.5px;
  top: 5px;
  img {
    width: 16.5px;
    height: 16.5px;
  }
}
.store_phone {
  margin: 0px 6px;
}
.store_btn {
  font-size: 12px;
  color: #1d2088;
  margin: 0px 5px 10px 0px;
}
//电话弹出框
.phone_popup {
  .phone_title {
    color: #595757;
    padding: 0 8px;
    font-size: 15px;
    text-align: center;
    margin: 15px 0 15px 0;
  }
  .van-popup--center {
    width: 275px;
    height: 241.5px;
  }
  .van-cell {
    color: #3e3a39;
    line-height: 16.5px;
    font-size: 15px;
    padding: 7.5px 12.5px;
  }
}
.van-card {
  background-color: white;
  /deep/ .van-image__img {
    width: 40px;
    height: 40px;
    margin: 5px 7.5px;
    border: 1px solid #9fa0a0;
    background-color: white;
    border-radius: 10px;
  }
}
.van-card__content {
  margin: 5px 0 0 7.5px;
}
.van-tag[data-v-9571ae72] {
  margin: 2.5px 0;
}
.store_recommend {
  background-color: #fff;
  h3 {
    font-size: 15px;
    margin: 5px 0 12.5px 132.5px;
  }
  .van-button {
    margin: 15px 0px 15px 136px;
    line-height: 20px;
    height: 20px;
    width: 102px;
  }
  .van-button--normal {
    font-size: 11px;
  }
}
.product_details {
  padding-bottom: 60px;
  h3 {
    margin-left: 150px;
  }
}
.bottom_line {
  margin: 17.5px 12.5px;
  border: 0.5px solid #eee;
  width: 350px;
}
.bottom_bar {
  .bottom_bar_text {
    margin-top: 2.5px;
    font-size: 13px;
    color: black;
  }
  .van-goods-action {
    z-index: 150;
    height: 49px;
  }
  .van-goods-action-icon {
    width: 50px;
    margin: 0px 12.5px;
  }
  .bottom_bar_btn {
    height: 39px;
    width: 355px;
    margin: 0px 10px;
    font-size: 15px;
  }
  .van-button--disabled {
    opacity: 1;
  }
}

//加入购物车弹窗
/deep/ .cart-popup {
  .cart-head {
    padding: 15px 0px 0px 12px;
    img {
      padding-right: 10px;
      width: 100px;
      height: 100px;
    }
    //折后价
    .cart-current {
      padding-top: 11.5px;
      .cart-discounted {
        width: 56px;
        height: 21px;
        line-height: 21px;
        display: inline-block;
        padding: 2.5px;
        color: white;
        font-size: 15px;
        text-align: center;
        background: -webkit-gradient(
          linear,
          left 0,
          right 100%,
          from(#ddb8c8),
          to(#ff0600)
        );
        border-radius: 21px;
      }
      .cart-original {
        padding-left: 7.5px;
        vertical-align: middle;
        font-size: 25px;
        font-weight: bold;
      }
    }
    //原价
    .cart_price {
      color: #969799;
      padding-top: 9px;
      span {
        font-size: 14px;
        padding: 0 3.5px 0 3.5px;
      }
      span:nth-of-type(2) {
        text-decoration: line-through;
      }
    }
    //返现
    .goods_make_money {
      margin: 12px 4px 0px;
      padding: 2.5px 0px;
      width: 42%;
      border: 1px solid #fd130e;
      border-radius: 5px;
      font-size: 12px;
      .goods-return {
        background: #fd130e;
        padding: 2.5px;
        color: #fff;
      }
      .goods-return-money {
        padding: 2.5px;
        color: #c31c1f;
      }
    }
  }
  //购买数量
  .pay_num {
    margin-right: 7.5px;
    padding: 15px 0px;
    .pay_title {
      font-size: 15px;
      line-height: 35px;
    }
    //input输入
    .van-stepper__minus {
      height: 28px;
      width: 28px;
    }
    .van-stepper__input {
      height: 28px;
      margin: 0;
      width: 28px;
      font-size: 12px;
    }
    .van-stepper__plus {
      height: 28px;
      width: 28px;
    }
  }
  // 商品radio的sku
  .radios-sku {
    .radio-title {
      padding: 5px 0;
      font-size: 15px;
    }
    .radio-name {
      padding: 4px 0;
      // padding: 8px 0;
      font-size: 13px;
    }
    .van-radio__icon {
      font-size: 15px;
    }
  }

  //服务方式
  .pay_service {
    padding-top: 10px;
    font-size: 15px;
    .pay_explain {
      font-size: 12px;
      color: #969799;
    }
    .pay_radio {
      padding-top: 15px;
      padding-bottom: 15px;
      .van-radio-group--horizontal {
        height: 20px;
      }
      .van-radio__icon {
        font-size: 12px;
      }
    }
    .van-radio__label {
      margin-right: 30px;
      font-size: 13px;
    }
  }
  //确认按钮
  .btn {
    margin-bottom: 10px;
    .btn_again {
      background-color: #f44d4d;
      color: #fff;
      width: 345px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      border-radius: 25px;
      margin-top: 15px;
    }
  }
}
/deep/.van-sku-messages {
  padding-bottom: 0px;
}

//自提弹窗
/deep/ .self_proposal {
  .van-picker__toolbar {
    height: 40px;
    line-height: 40px;
  }
  .van-picker__title {
    font-size: 15px;
    color: black;
  }
  .van-picker-column__item {
    font-size: 15px;
  }
  .van-picker__cancel,
  .van-picker__confirm {
    font-size: 13px;
  }
}
.product-mobile {
  /deep/ p {
    font-size: 15px;
  }
  /deep/ h1 {
    font-size: 15px;
  }
  /deep/ h2 {
    font-size: 15px;
  }
  /deep/ h3 {
    font-size: 15px;
  }
  /deep/ img {
    width: 100%;
  }
}
//去掉视频全屏按钮
// video::-webkit-media-controls-fullscreen-button {
//   display: none;
// }
</style>


